var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "layout",
    [
      _c("template", { slot: "header" }, [_c("pitaya-header")], 1),
      _vm._v(" "),
      _c("template", { slot: "main" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("template", { slot: "side-navbar" }, [_c("side-navbar")], 1),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }